import Modal from "src/pages/Modals/ModalBase";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { trackAnalytics } from "src/pages/helpers";
import { EVENT_NAMES, EVENT_PARAMETERS, MODAL_NAMES } from "src/utils/EventConstants";
import { setShowContactHelpModal } from "src/store/slices/modalSlice";

const SUPPORT_EMAIL = "support@inhouse.ai";

const QuestionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 256 256">
    <path d="M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" />
  </svg>
);

const ContactHelpModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.modalSlice.showContactHelpModal);

  useEffect(() => {
    if (isOpen) {
      trackAnalytics(EVENT_NAMES.VIEWED_MODAL, {
        [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.CONTACT_HELP_MODAL,
      });
    }
  }, [isOpen]);

  const handleClose = () => {
    trackAnalytics(EVENT_NAMES.CLOSED_MODAL, {
      [EVENT_PARAMETERS.MODAL_NAME]: MODAL_NAMES.CONTACT_HELP_MODAL,
    });
    dispatch(setShowContactHelpModal(false));
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      contentAreaStyles="!max-w-[600px]"
      bodyStyle={{ padding: 0, overflow: "hidden" }}
      bodyClassName="!py-0"
    >
      <div className="w-screen md:w-[600px] px-[10px] py-[80px] bg-[#FCFCFC] flex flex-col gap-[20px] justify-center items-center">
        <span className="text-[#343330]">
          <QuestionIcon />
        </span>
        <div className="flex flex-col gap-[4px] px-14 md:px-0">
          <h2 className="text-[24px] text-[#1b2b48] text-center leading-[33.6px] font-[lora] font-bold italic">
            Looking for help?
          </h2>
          <p className="text-[14px] md:text-[16px] font-medium text-[#011513] text-center leading-[21px] mt-2">
            Drop an email to{" "}
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="font-medium text-[#1c627d]"
              target="_blank"
              rel="noreferrer"
            >
              {SUPPORT_EMAIL}
            </a>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ContactHelpModal;
